import React from 'react';
import Button from '../../../Components/Button/Button';
import TechIcon from '../../../Utils/Icons/Icons';
import { useNavigate } from "react-router-dom";
import './Portfolio.css';

const PortfolioCard = ({ project, sectionCategory }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    sessionStorage.setItem("portfolio-page-scroll", window.scrollY);
    
    const carousel = document.querySelector(
      `.portfolioCardsContainer[data-category="${sectionCategory}"]`
    );
    if (carousel) {
      sessionStorage.setItem(
        `portfolio-carousel-scroll-${sectionCategory}`,
        carousel.scrollLeft
      );
    }

    navigate(`/portfolio/${project.id}`);
  };

  return (
    <div className="portfolioProjectCard">
      <div className="portfolioCardImg">
        <img src={project.image} alt={project.title} />
      </div>

      <h3 className="portfolioCardTitle">{project.title}</h3>
      <p className="portfolioCardDesc">{project.description}</p>

      <Button className="portfolioViewBtn" onClick={handleNavigate}>
        {project.buttonText || "View Project"}
        <TechIcon name="move-right" className="portfolioArrow" size={10} />
      </Button>
    </div>
  );
};

export default PortfolioCard;
